import styled from 'styled-components';
import {SelectList} from '@/components/SelectList';
import {RADIUS_OPTIONS} from '@/map/constants';
import {distanceToString} from '@/map/utils';

interface IProps {
  radius?: number;
  onChange(radius: (typeof RADIUS_OPTIONS)[0]): void;
}

export const RadiusDropdown = ({radius, onChange}: IProps) => {
  if (!radius) {
    return null;
  }

  const options = RADIUS_OPTIONS.filter((i) => i !== radius).map((i) => ({
    value: i,
    label:
      i === 'reset'
        ? '다시 그리기'
        : distanceToString(i, {roundingMode: 'ceil'}),
  }));

  return (
    <Root>
      <SelectList
        size="small"
        placeholder={distanceToString(radius, {roundingMode: 'ceil'})}
        activePlaceholder
        list={options}
        onSelected={(selected) => onChange(selected?.[0]?.value)}
      />
    </Root>
  );
};

const Root = styled.div`
  min-width: 78px;
  max-width: 84px;
  flex-shrink: 0;
`;
